export default __webpack_public_path__ + "static/media/woodcut-boar.625e13a9.png";